import {unionContexts} from 'r/utils';
import {func, object} from 'prop-types';
import {ProfileContext} from 'r/contexts';
import {forbidExtraProps} from 'airbnb-prop-types';
import {Button} from '@/components/ui/button';
import logoutSvg from './logout.svg';

export default unionContexts(Profile, [ProfileContext, 'profile', 'logout']);

Profile.propTypes = forbidExtraProps({
  profile: object.isRequired,
  logout: func.isRequired,
});

function Profile({profile, logout}) {
  return (
    <div className="flex flex-col items-center justify-center w-full max-w-2xl h-full bg-background">
      <header className="text-center text-main text-header-18 font-semibold p-6">
        Profile
      </header>
      <div className="w-full grow overflow-y-auto px-4">
        <div className="space-y-6">
          <div className="flex justify-between items-center">
            <span className="text-main text-body-16 font-semibold">
              Web3 wallet
            </span>
            {profile.address ? (
              <div className="flex items-center gap-2 bg-bg-main rounded-full px-3 py-1.5 text-main text-body-12 font-semibold">
                {`u_${profile.address.slice(0, 6)}.${profile.address.slice(-6)}`}
              </div>
            )
              : null}
          </div>
        </div>
      </div>
      <div className="mt-auto p-4 flex justify-center">
        <Button
          className="text-(--bearish) hover:text-(--bearish)"
          onClick={logout}
          variant="ghost"
        >
          <img alt="" className="w-5 h-5 mr-2" src={logoutSvg}/>
          Log Out
        </Button>
      </div>
    </div>
  );
}
